import { render, staticRenderFns } from "./AdmissionList.vue?vue&type=template&id=5a5518ce&"
import script from "./AdmissionList.vue?vue&type=script&lang=js&"
export * from "./AdmissionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports